import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500">实时更新快讯，不错过任何一部精彩漫画的更新</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updatesData.map((item, idx) => (
            <div key={item.id} className="flex gap-4 relative pb-6 last:pb-0">
              {idx < updatesData.length - 1 && (
                <div className="absolute left-[18px] top-10 bottom-0 w-px bg-background-300/60"></div>
              )}
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center shrink-0 mt-0.5 relative z-10">
                <div className="w-3 h-3 rounded-full bg-primary-500"></div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-semibold text-foreground-900 text-sm mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}